<section class="report">
  @if (report) {
    <header class="report__head">
      <h1 class="report__title">{{ report.title }}</h1>
      <p class="report__desc">{{ report.description }}</p>
    </header>

    <div class="report__toolbar">
      @if (report.requiresYear) {
        <div class="field">
          <label for="reinsuranceYear">Reinsurance Year</label>
          <p-select
            inputId="reinsuranceYear"
            [options]="years"
            [(ngModel)]="selectedYear"
            [style]="{ minWidth: '150px' }">
          </p-select>
        </div>
        <button
          pButton
          type="button"
          label="Load report"
          icon="pi pi-refresh"
          [disabled]="loading"
          (click)="load()">
        </button>
      }

      <button
        pButton
        type="button"
        class="export-btn"
        label="Export to Excel"
        icon="pi pi-file-excel"
        [disabled]="loading || exporting || !rows.length"
        (click)="exportExcel()">
      </button>
    </div>

    @if (error) {
      <p class="report__error" role="alert">{{ error }}</p>
    }

    <div class="report__tablewrap">
      <div class="report__caption">
        <span class="report__caption-title">
          {{ report.title }}@if (report.requiresYear) {&nbsp;— RY {{ selectedYear }}}
        </span>
        <span class="report__caption-meta">
          @if (runDate) {Quarter run date {{ runDate }} · }{{ totalRecords }} rows
        </span>
      </div>

      <p-table
        [value]="rows"
        [columns]="report.columns"
        [loading]="loading"
        [scrollable]="true"
        scrollHeight="520px"
        [lazy]="!!report.paged"
        [lazyLoadOnInit]="false"
        [totalRecords]="totalRecords"
        (onLazyLoad)="onLazyLoad($event)"
        [paginator]="totalRecords > 10"
        [(first)]="first"
        [(rows)]="pageSize"
        [rowsPerPageOptions]="[10, 20, 50]"
        paginatorDropdownAppendTo="body"
        styleClass="p-datatable-sm p-datatable-gridlines">
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of columns; track col.field) {
              <th [class.num]="col.type === 'number'">{{ col.header }}</th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns">
          <tr>
            @for (col of columns; track col.field) {
              <td [class.num]="col.type === 'number'">{{ formatCell(row, col) }}</td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="report.columns.length" class="report__empty">
              No data for this selection.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <div class="report__notfound">
      <h1>Report not found</h1>
      <p>This report doesn’t exist. <a routerLink="/">Return to divisions</a>.</p>
    </div>
  }
</section>
